module.exports = __webpack_public_path__ + "img/logo_outback@3x.366e63b9.png";